import './WhyCard.css'
import CardHorizontal from '../../../components/Card/CardHorizontal.jsx'


export default function WhyCard() {
    return (
        <div className='whyCard__main'>
            <h2>Почему именно мы</h2>
            <div className="whyCard__container">
                <CardHorizontal
                    title = "Доступность & гибкость"
                    text = "// Наши решения удобны для всех пользователей и мы постоянно заботимся о масштабируемости программных решений и гибкости в подходе к обслуживании. "
                />
                <CardHorizontal
                    title = "Инновации & развитие"
                    text = "// Мы создаем инновации, обучаем наших клиентов использовать передовые технологии и помогаем расти бизнесу с помощью IT технологий."
                />
                <CardHorizontal
                    title = "Забота & польза"
                    text = "// Постоянно стремимся удовлетворить Ваши потребности и решаем конкретные задачи."
                />
            </div>
        </div>
    )
}
